<template>
  <div v-show="value" ref="dialog" class="captchaDialog">
    <img src="//vipcdn.mgtv.com/upload/20180408/close.png" class="close" @click="handleAction('cancel')"/>
    <div class="content">
      <div class="input_wrap">
        <input ref="input" type="text" placeholder="请输入图片验证码" class="captcha_input"/>
        <img :src="captcha"
             class="captcha_img"/>
      </div>
      <div class="submit" @click.prevent="click_button" v-if="button">
        {{button}}
      </div>
    </div>
  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';
  import {setStyle} from '../../../tools/dom'

  export default create({
    name: 'CaptchaDialog',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      captcha: {
        type: String,
        default: ""
      },
      button: {
        type: String,
        default: "确认"
      },
      submitAction: {
        type: Function,
        default: function (value) {
          console.log("CaptchaDialog submitAction", value);
        }
      }
    },
    data: function () {
      return {}
    },
    methods: {
      handleAction: function (action, value) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action, value);
      },
      click_button: function () {
        const value = this.$refs.input.value.trim();
        if (value.length === 0) {
          return;
        }
        this.handleAction('confirm', value);
        // this.submitAction(value);
      }
    },
    mounted() {
    },
    watch: {},
    computed: {}
  });
</script>


<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"

  .captchaDialog
    padding 1.1rem .3rem .5rem .3rem
    background white
    center()
    border-radius 0.2rem
    color #717171
    position fixed !important

  .close
    position absolute
    top -.2rem
    right 0
    width .73rem
    height .84rem
    z-index 2
    box-sizing content-box
    padding .2rem

  .content
    overflow hidden
    position relative
    width 5.6rem

    .input_wrap
      position relative
      display block
      margin 0 auto
      width: 5.6rem;
      height: 0.8rem;
      background-color: #f3f3f3;
      border-radius .9rem
      .captcha_input
        width: 3.5rem;
        height: 100%
        background transparent
        padding 0 .4rem
        line-height @height
        font-size: 0.3rem;
        outline none
        border none
      .captcha_img
        position absolute
        right .4rem
        border none
        font-size: 0.26rem;
        color #55a1ff
        top .1rem
        height .6rem

    .submit
      background url(//vipcdn.mgtv.com/upload/20180408/btn.png) no-repeat
      background-size cover
      width 3.168rem
      height .84rem
      text-align center
      color white
      margin .4rem auto 0 auto
      font-size .3rem
      padding-top .16rem

  .inline-block
    display inline-block
</style>



// WEBPACK FOOTER //
// src/components/Popups/CaptchaDialog/CaptchaDialog.vue